export const GIFT_ORDER_SESSION_STORAGE = 'giftOrderMetadata'
